export const STEPS = Object.freeze({
  IDENTIFIER:      'identifier',
  SIGN_IN_METHOD:  'sign_in_method',
  MAGIC_LINK_SENT: 'magic_link_sent',
  PASSWORD:        'password',
  FORGOT_PASSWORD:        'forgot_password',
  RESET_LINK_SENT:        'reset_link_sent',
  SET_PASSWORD_FROM_LINK: 'set_password_from_link',
  CHOOSE_METHOD:          'choose_method',
  VERIFY:                 'verify',
  TRUST:                  'trust',
  CLASSIC_PHONE:          'classic_phone',
  CLASSIC_PASSWORD:       'classic_password',
  CLASSIC_VERIFY:         'classic_verify',
})

export const MFA_METHOD = Object.freeze({
  SMS:   1,
  EMAIL: 2,
})
